<template>
  <main>
    <div class="carousel-hero">
      <div
        id="homeCarousel"
        class="carousel slide carousel-fade"
        data-ride="carousel"
        data-interval="5000"
      >
        <div class="carousel-inner">
          <div
            v-for="(slide, index) in slides"
            :key="slide.id"
            class="carousel-item"
            :class="{active: index == 0}"
          >
            <div
              class="carousel-image d-block w-100"
              :style="{
                backgroundImage: 'url(' + slide.image.path_full + ')',
                ...([3914, 4224, 4043].includes(slide.id) || slide.title === '.' ? {
                  backgroundSize: 'contain',
                } : {})
              }"
            />
            <div
              class="carousel-caption d-flex flex-wrap align-content-center"
              :class="[slide.meta['caption-class']]"
            >
              <div class="text-center flex-grow-1">
                <h5>{{ slide.title }}</h5>
                <p
                  v-if="slide.content !== '<p><br></p>'"
                  v-html="slide.content"
                />
              </div>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#homeCarousel"
          role="button"
          data-slide="prev"
        >
          <span
            class="carousel-control-prev-icon"
            aria-hidden="true"
          />
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#homeCarousel"
          role="button"
          data-slide="next"
        >
          <span
            class="carousel-control-next-icon"
            aria-hidden="true"
          />
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>

    <div class="container-fluid bg-white ">
      <div class="container">
        <div class="row py-3 py-sm-5">
          <div class="col-12 text-center">
            <h1 class="pb-2 text-page-title">
              <img
                class="mt-n2"
                src="/img/logo/logo.png"
                alt="Logo"
                width="auto"
                height="40"
              >
              Welcome to Food Fitness First<sup><small>®</small></sup> Home of the FOOD SPIRAL<sup><small>&reg;</small></sup>
            </h1>
          </div>
        </div>

        <LoginForm class="pb-4" />
      </div>
    </div>
  </main>
</template>

<script>
import Slides from '../services/slides.js';
import Posts from '../services/posts.js';
import Recipes from '../services/recipes.js';
import LoginForm from "../components/LoginForm.vue";

export default {
  components: {
    LoginForm,
  },
  data () {
    return {
      slides: [],
      posts: [],
      recipes: [],
      isCordova: window.IS_CORDOVA,
    }
  },
  created () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      Slides.all().then(res => {
        this.slides = res.data
      });

      Posts.all({page: 1, perpage: 3}).then(res => {
        this.posts = res.data
      });

      Recipes.all({page: 1, perpage: 3}).then(res => {
        this.recipes = res.data
      });
    }
  }
}
</script>

<style scoped>
span.label {
    color: #d79e28;
    font-weight: bold;
}

b {
    font-weight: bold;
}

.bullet_logo {
    list-style: none;
    padding-left: 10px;
}
.bullet_logo li {
    position: relative;
    padding-left: 50px;
    padding-top: 10px;
}
.bullet_logo li:before {
    content: '';
    width: 20px;
    height: 30px;
    position: absolute;
    background-image: url('/img/logo/logo.png');
    background-size: cover;
    background-position: center;
    left: 14px;
    top: 1.05em;
    transform: translateY(-50%);
}
.btn-signup-custom-outline {
    color: rgb(95, 159, 59);
    border: 2px solid rgba(94, 158, 58, 0.8);
}
</style>
